import Swiper from 'swiper';
import { Navigation, Virtual, A11y, Pagination } from 'swiper/modules';
import 'swiper/css';

const defaultOptions = {
	modules: [Navigation, Virtual, A11y],
	direction: 'horizontal',
	loop: false,
	slidesPerView: 'auto',
	spaceBetween: 8,
  breakpoints: {
    601: {
      slidesPerView: 2,
      spaceBetween: 8,
    },
    1201: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  a11y: {
    prevSlideMessage: 'Forrige slide',
    nextSlideMessage: 'Næste slide',
  },
};

const reviewOptions = {
  spaceBetween: 8,
  slidesPerView: 'auto', 
  breakpoints: {
    601: {
      slidesPerView: 2.5,
      spaceBetween: 16,
    },
  },
}

const carouselOptions = {
  modules: [Navigation, Pagination],
  spaceBetween: 0,
  slidesPerView: 'auto',
  breakpoints: {
    601: {
      slidesPerView: 1.5,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

function initStandardSlider(container) {
  const swiperEl = container.querySelector('.swiper');
  const prevButton = container.querySelector('.swiper-button-prev');
  const nextButton = container.querySelector('.swiper-button-next');

  if (!swiperEl) return;

  const swiper = new Swiper(swiperEl, {
    ...defaultOptions,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    on: {
      init: function () {
        updateNavButtonsStates(this, prevButton, nextButton);
        toggleSwiperControls(this);
      },
      slideChange: function () {
        updateNavButtonsStates(this, prevButton, nextButton);
      },
    },
  });
}

function initReviews(container) {
  const swiperEl = container.querySelector('.swiper-reviews');

  if (!swiperEl) return;

  const swiper = new Swiper(swiperEl, {
    ...reviewOptions,
  });
}

function initCarousel(container) {
  const swiperEl = container.querySelector('.swiper-carousel');
  const prevButton = container.querySelector('.swiper-button-prev');
  const nextButton = container.querySelector('.swiper-button-next');
  const paginationEl = container.querySelector('.swiper-pagination');

  if (!swiperEl) return;

  const swiper = new Swiper(swiperEl, {
    ...carouselOptions
  });


  function updateNavigation() {
    const isMobile = window.innerWidth < 1200;

    swiper.params.pagination.el = isMobile ? paginationEl : null;
    swiper.params.pagination.clickable = isMobile;
    swiper.params.navigation.nextEl = !isMobile ? nextButton : null;
    swiper.params.navigation.prevEl = !isMobile ? prevButton : null;

    if (isMobile) {
      paginationEl?.classList.remove('hidden');
      prevButton?.classList.add('hidden');
      nextButton?.classList.add('hidden');
    } else {
      paginationEl?.classList.add('hidden');
      prevButton?.classList.remove('hidden');
      nextButton?.classList.remove('hidden');
    }

    swiper.update();
  }

  updateNavigation();
  window.addEventListener('resize', updateNavigation);
}

// Toogle navigation controls according to the amount of items
function toggleSwiperControls(swiper) {
  const nextBtn = swiper.navigation?.nextEl;
  const prevBtn = swiper.navigation?.prevEl;

  const scrollingPossible = swiper.wrapperEl.scrollWidth > swiper.width;

  if (nextBtn) nextBtn.style.display = scrollingPossible ? '' : 'none';
  if (prevBtn) prevBtn.style.display = scrollingPossible ? '' : 'none';
}

function updateNavButtonsStates(swiper, prevButton, nextButton) {
  if (!prevButton || !nextButton) return;

  prevButton.classList.toggle('disabled', swiper.realIndex === 0);
  nextButton.classList.toggle('disabled', swiper.realIndex === swiper.slides.length - 1);
}


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.slider-component').forEach(initStandardSlider);
  document.querySelectorAll('.reviews').forEach(initReviews);
  document.querySelectorAll('.carousel-component').forEach(initCarousel);
});